function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8 0h148a8 8 0 0 1 8 8v93H0V8a8 8 0 0 1 8-8z",
  id: "a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#CCE6D8",
  width: 164,
  height: 150,
  rx: 8
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M121.666 69.948v31.96c0 7.79-3.836 15.083-10.237 19.379L98.6 129l-11.767-7.866c-7.006-4.168-11.31-11.818-11.31-20.065V69.948l22.917-6.76.16.05 23.065 6.71",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#E12929"
}, /*#__PURE__*/React.createElement("path", {
  d: "M92.793 112.75h11.604V77.812H92.793z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.19 101.104H116V89.458H81.19z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M113.167 12C124.12 12 133 20.912 133 31.906c0 10.994-8.88 19.907-19.833 19.907-10.954 0-19.834-8.913-19.834-19.907S102.213 12 113.167 12",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#E15D29"
}, /*#__PURE__*/React.createElement("path", {
  d: "m120.232 32.166-10.781 6.087c-2.051 1.159-4.666.46-5.838-1.559a4.165 4.165 0 0 1-.416-3.203 4.194 4.194 0 0 1 2.002-2.555l10.78-6.087c2.048-1.155 4.662-.455 5.838 1.567a4.14 4.14 0 0 1 .413 3.199 4.184 4.184 0 0 1-1.998 2.55",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "m120.22 32.079-5.471 3.132-4.482-7.221 5.471-3.132c2.077-1.19 4.767-.538 6.006 1.457.618.998.757 2.14.48 3.184a4.193 4.193 0 0 1-2.003 2.58"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M78.762 91.625c0-.44-.153-.813-.343-.813h-3.362c-.186 0-.343.362-.343.813 0 .44.152.813.343.813h3.362c.19-.012.343-.373.343-.813M71.476 103.135V90.812h-3.238v12.323c0 .824.637 1.49 1.425 1.49h.388c.788 0 1.425-.666 1.425-1.49",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.476 91.625c0-.44-.152-.813-.342-.813H67.77c-.186 0-.343.362-.343.813 0 .44.153.813.343.813h3.363c.19-.012.342-.373.342-.813",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.666 103.41v-8.535h-2.428v8.534a1.214 1.214 0 1 0 2.428 0",
  fill: "#EED0D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.38 103.135V90.812h-3.237v12.323c0 .824.637 1.49 1.424 1.49h.389c.788 0 1.425-.666 1.425-1.49",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.19 91.625c0-.44-.152-.813-.342-.813h-3.363c-.185 0-.342.362-.342.813 0 .44.152.813.342.813h3.363c.19-.012.342-.373.342-.813",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.571 103.41v-8.535h-2.428v8.534a1.214 1.214 0 1 0 2.428 0",
  fill: "#EED0D0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA9496",
  d: "M55.286 107.063h-1.62v-16.25h1.62z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.225 21.97c.243-4.345-2.853-8.645-6.994-9.71-4.141-1.064-8.873 1.225-10.68 5.167-1.549 3.374-1.018 7.327-.271 10.977.741 3.65 1.667 7.426.817 11.048-.72 3.05-2.652 5.74-3.037 8.85-.525 4.277 2.43 8.721 6.529 9.807 2.317.612 5.31-.143 6.046-2.464.682-2.15-.877-4.438-.563-6.671.265-1.875 1.765-3.264 3-4.676 4.546-5.215 4.611-12.73 5.153-22.328",
  fill: "#151414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.26 76.529c2.205-2.422 3.817-6.783 3.817-8.251 0-1.735.288-3.514-.345-5.137-.328-.837-.83-1.596-1.33-2.35-.57-.859-1.134-1.718-1.704-2.577-.236-.354-.507-.731-.927-.842-.708-.183-1.359.588-1.324 1.297.04.704.524 1.302 1.359 1.928a7.56 7.56 0 0 0-1.94-3.463c-.248-.255-.582-.51-.939-.432-.582.133-.564.93-.409 1.485.392 1.39.777 2.781 1.088 3.978-1.232 2.261-1.122 4.943-1.145 7.492-.023 2.55-.282 5.309-2.033 7.226 1.681.71 3.662-2.117 5.832-.354",
  fill: "#F3B894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.905 75.901s-5.451 18.56-9.57 18.94c-4.984.466-9.033-4.126-9.033-4.126l-3.255-16.623 7.38-4.404 4.07 13.32 5.81-6.545 4.598-.562",
  fill: "#F3B894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.834 77c3.973-1.569 7.96-3.105 11.928-4.696-1.083-5.415-2.585-11.904-3.899-13.978-2.46-3.879-6.431-4.076-6.431-4.076l-1.813 5.601.215 17.034V77",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#404040",
  d: "m69.857 87.572 12-30.885 14.714 3.8-13.618 34.388-13.096-7.303"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEF5F8",
  d: "m72.286 86.61 10.358-27.485 11.499 3.238-11.327 30.075-10.53-5.827"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "m86.003 57.5-.765 1.966 4.807 1.284.86-2.009-4.902-1.241"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.348 58.84c.517-3.23 12.394-7.38 16.431-7.004 8.67.813 14.951 2.433 16.928 3.709 1.977 1.276 3.781 13.193 3.781 16.514 0 3.929-1.313 11.642-.962 14.753.68 6.034 4.236 18.812 4.236 18.812l-13.069 4.715-1.621-2.939-1.48 3.725-21.598-5.097s1.652-17.703 1.652-20.81c-.005-2.976-4.968-22.213-4.298-26.379",
  fill: "#2B9D8B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.714 60.75c4.416 23.694 4.661 30.48 5.667 47.125",
  stroke: "#FFF",
  strokeWidth: 0.81,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.905 64.813a.81.81 0 0 0-.81.812.81.81 0 1 0 1.62 0 .81.81 0 0 0-.81-.813M59.333 76.188a.81.81 0 0 0-.81.812.81.81 0 1 0 1.62 0 .81.81 0 0 0-.81-.813",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.952 86.75a.81.81 0 0 0-.81.813.81.81 0 1 0 1.62 0 .81.81 0 0 0-.81-.813",
  fill: "#216484"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.952 98.938a.81.81 0 0 0-.81.812.81.81 0 1 0 1.62 0 .81.81 0 0 0-.81-.813",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m83.619 76.776-2.158.205-.167.019-14.468-4.53c-.99-.627-1.157-1.597-.923-2.386.298-.982 1.262-1.442 2.09-1.094l13.802 5.817.14.149 1.684 1.82",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("path", {
  d: "m82.95 76.82-1.76.18c.053-.052.112-.105.159-.172.205-.262.328-.65.24-1.002-.035-.15-.105-.306-.059-.449.024-.067.07-.112.106-.164.117-.172.2-.19.159-.406a1261641.093 1261641.093 0 0 0 .68.703l.645.668.499.575-.669.068z",
  fill: "#C88256"
}), /*#__PURE__*/React.createElement("path", {
  d: "m82.95 76.82-1.258.118c.142-.217.466-.762.522-1.044.044-.215.067-.373.05-.603l1.355 1.462-.669.068z",
  fill: "#1B1415"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.81 79.057c1.476-2.698 2.948-5.397 4.523-8.102 1.168-.896 2.483-1.573 3.825-2.08 1.601.512 3.106 1.456 4.345 2.726.303.314.622.757.481 1.178-.103.31-.427.46-.73.438-.298-.022-.58-.182-.85-.336-.817-.47-1.634-.944-2.58-1.398-.266.224-.53.448-.731.678.552.005 1.104.016 1.764.202 1.055.491 2.088 1.051 3.09 1.68.28.177.589.411.622.763.027.288-.152.55-.385.672-.232.123-.497.128-.757.107a5.042 5.042 0 0 1-2.651-.976c-.314.09-.628.181-.866.33.406.075.812.15 1.19.337.38.186.725.496.893.917.168.422.108.955-.114 1.398.217.08.336.357.325.608-.01.25-.119.474-.227.688-.233.453-.487.89-.763 1.307-.265.389-.568.773-.985.944a.98.98 0 0 1-1.239-.464c-1.114 1.899-3.203 3.013-5.226 2.8a16.514 16.514 0 0 1-2.955-4.417",
  fill: "#F3B894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.286 72.465c.475-.211.98-.283 1.495-.34m-.53 2.592c.481-.042.953-.026 1.313.04m1.77 2.494c-.67-.396-1.775-.623-2.534-.52m.24 3.519c.236-.407.442-1.077.534-1.546m-.154.84c.303.041.62.098.865.072",
  stroke: "#312318",
  strokeWidth: 0.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.857 83.575S51.53 99.81 46.583 97.981c-1.968-.73-3.919-6.69-5.335-12.24-1.304-5.101-2.153-9.848-2.153-9.848l10.383-4.58s.695 4.918 1.395 8.917c.461 2.697.928 4.974 1.177 5.04 1.06.31 14.514-5.943 14.514-5.943l3.293 4.248",
  fill: "#F3B894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.238 79.85c-2.554 1.622-6.57 4.013-9.922 5.275-1.346-4.883-2.22-9.427-2.22-9.427l10.709-4.385s.711 4.708 1.433 8.536",
  fill: "#E69378",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.168 81.063c4.685-.88 8.402-1.642 12.88-3.224-.635-5.195-2.116-14.59-3.319-17.485-.853-2.052-4.204-5.659-7.98-4.098-3.778 1.56-5.227 4.023-4.828 10.519.148 2.31 2.373 9.584 3.247 14.287",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.143 53.896s-.998 5.175-2.924 6.688c-1.926 1.512-9.22-7.79-9.22-7.79 1.257-1.343 1.56-3.976 1.545-6.307-.015-2.377-.363-4.425-.363-4.425l8.887 2.94c-.09 2.514-.03 4.388.367 5.63.736 2.305 3.107 2.305 3.107 2.305",
  fill: "#F3B894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.524 51.63c-3.944.922-6.896-2.808-8.492-4.805-.015-2.203-.413-3.138-.413-3.138l8.556 2.725c-.091 2.335.241 3.787.509 4.994",
  fill: "#E69378",
  opacity: 0.34
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.699 61.547c.119-.024-.477-3.666-.777-3.98-.3-.314-7.608-7.645-8.043-7.372-.637.391-1.689 2.716-1.689 2.716s1.502 2.331 4.335 4.964c1.948 1.81 5.055 3.891 6.174 3.672M58.099 56.777c.59-1.05.954-3.101.954-4.965 0 0 2.457.588 2.679 1.03.216.45-.787 3.22-1.537 4.782-1.275 2.63-2.313 3.25-2.439 3.107-.156-.176.161-3.636.343-3.954z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.228 38.314c-.13-1.773-1.498-2.988-3.057-2.713-1.56.275-2.719 1.937-2.59 3.71.13 1.773 1.498 2.988 3.057 2.712 1.56-.275 2.719-1.936 2.59-3.709",
  fill: "#EEAB8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.952 33.359c0-7.758 5.074-14.047 11.334-14.047s11.333 6.29 11.333 14.047c0 7.758-3.127 15.471-9.47 15.196-6.25-.275-13.197-7.438-13.197-15.196",
  fill: "#F3B894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.213 37.188c1.333-1.526 2.176-4.406 2.381-5.633 1.275-.388 2.819-1.675 3.593-3.412 1.944 2.047 9.33 3.202 11.795 2.525 1.754 2.28 1.807 3.412 2.429 6.325.4-3.557.221-7.186-.522-10.681-4.62-1.57-9.14-3.463-13.523-5.671-.748-.378-1.643-.76-2.36-.317-.458.283-.695.833-.932 1.338a16.869 16.869 0 0 1-4.141 5.543c-.448.394-.959.838-.98 1.448-.016.4.185.766.369 1.116.827 1.603.685 5.46 1.891 7.419",
  fill: "#E69378",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.047 28.154c.036 2.887-2.198 8.882-2.198 8.882s-.015-4.935-2.152-8.141c-4.421 0-9.32-.216-12.032-2.865-.786 2.097-2.137 3.319-3.765 3.892.052 2.616-1.088 5.065-1.802 7.265-1.392-.891-2.44-.513-3.574-1.924-.658-2.557-1.356-6.552-1.156-9.022.164-1.99.678-4 1.705-5.671.241-.4.519-.784.822-1.14 1.582-1.844 4.077-2.92 6.363-2.32 1.263-1.6 3.214-2.546 5.16-2.66 1.952-.113 3.888.53 5.588 1.552 3.313 1.984 5.9 5.054 6.748 9.325.185.919.278 1.865.293 2.827",
  fill: "#1B1918"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.857 29.063c-.099-.376-.22-.746-.357-1.11-.676-1.769-1.775-3.358-3.039-4.778-1.906-2.166-4.274-4.032-7.071-4.805-2.797-.767-6.044-.283-8.132 1.714-2.637-1.11-5.874-.506-8.115 1.339.258-.403.555-.79.879-1.148 1.692-1.856 4.362-2.939 6.808-2.335 1.351-1.61 3.44-2.563 5.521-2.677 2.088-.114 4.16.533 5.979 1.562 3.543 1.997 6.313 5.087 7.22 9.386.192.93.29 1.883.307 2.852",
  fill: "#211E1D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.348 35.746c-1.099-.593-2.156.298-2.36 1.992-.206 1.693.518 3.547 1.616 4.14 1.099.594 2.156-.297 2.361-1.99.205-1.694-.519-3.548-1.617-4.142",
  fill: "#F3B894"
}))));

function SvgNurseRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseRequest);
export default __webpack_public_path__ + "static/media/nurse_request.6ee4ae37.svg";
export { ForwardRef as ReactComponent };